import { INVITES } from '../constants/actionTypes';

const initial = { items: [], total: 0, loading: false, error: null };

export default function invitesReducer(state = initial, action) {
  switch (action.type) {
    case INVITES.LIST_REQUEST: return { ...state, loading: true, error: null };
    case INVITES.LIST_SUCCESS: return { ...state, loading: false, items: action.payload.items, total: action.payload.total };
    case INVITES.LIST_FAILURE: return { ...state, loading: false, error: action.payload };
    case INVITES.CREATE:       return { ...state, items: [action.payload, ...state.items], total: state.total + 1 };
    case INVITES.UPDATE:       return { ...state, items: state.items.map(i => i._id === action.payload._id ? action.payload : i) };
    case INVITES.REMOVE:       return { ...state, items: state.items.filter(i => i._id !== action.payload), total: Math.max(0, state.total - 1) };
    default: return state;
  }
}
